import React, { useEffect, useMemo, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import { getTsDate, getUserStation, notify } from '../../../../utils';
import { useAppContext } from '../../../../context';
import { IFile, IVisualReporting } from '../../../../globals/interfaces';
import _ from 'lodash';
import { useAuth0 } from '@auth0/auth0-react';
import styled from 'styled-components';
import { Label } from 'reactstrap';
import { Input } from 'reactstrap';
import ActionIcon from '../../../../components/custom/ActionIcon';
import ModalAddDamageReport from './ModalAddDamageReport';
import useModal from '../../../../customHooks/useModal';
import { Collection } from '../RenderImages';
import apiClient, { apiClientEosNative } from '../../../../apiClient';
import VirtualTable from '../../../../components/custom/VirtualTable';
import LightBox from './LightBox';

const DamageReporting = () => {

    const { user } = useAppContext();
    const [search, setSearch] = useState('');
    const [data, setData] = useState<Array<IVisualReporting>>([]);
    const [searchComplete, setSearchComplete] = useState(false);
    const [collectionId, setCollectionId] = useState<string>('');
    const { modal, setModal } = useModal();
    const { modal: lightBoxOpen, setModal: setLightBoxOpen } = useModal();

    const collections = useMemo(() => {
        const map: Record<string, Collection> = {};
        for (const item of data) {
            const { 
                collection_id: collectionId, 
                user_submitted: createdBy, 
                time_submitted: createdAt, 
                comments,
                file_link: url,
                awb_uld: title 
            } = item;

            if (!map[collectionId]) {
                map[collectionId] = {
                    title,
                    collectionId,
                    createdBy,
                    createdAt,
                    comments,
                    images: []
                };
            }

            map[collectionId].images.push({
                url,
                title,
                comments,
                collectionId,
                createdBy,
                createdAt
            });
        }

        return Object.keys(map).map(key => map[key]);
    }, [data]);
    const collection = collections.find(collection => collection.collectionId === collectionId);

    const getData = async () => {
        setSearch('');
        const res = await apiClient.get(`/visualReportingData/${user.s_unit}`);
        setData(res.data);
    }

    useEffect(() => {
        getData();
    }, [user.s_unit]);

    useEffect(() => {
        if (!search || search.length === 0) {
            setSearchComplete(false);
        }
    }, [search]);

    const trySearch = async () => {
        setSearchComplete(false);
        const res = await apiClient.get(`visualReportingDeepSearch/${search}`);
        setData(res.data);
        setSearchComplete(true);
    };

    const submitDamageReport = async (awb_uld: string, comments: string, files: Array<IFile>) => {
        const body = {
            files,
            awb_uld,
            user_submitted: user.s_email,
            comments,
            time_submitted: getTsDate(),
            full_name: user.displayName,
            unit: user.s_unit,
            collection_id: uuidv4(),
        }

        try {
            await apiClientEosNative.post(`/damage-report`, body)
        } catch (err) {
            alert(err);
        }

        notify('Report Submitted');
        setModal(false);
    }

    const viewReport = (collectionId: string) => {
        setCollectionId(collectionId);
        setLightBoxOpen(true);
    }

    return (
        <Container>
            <SearchContainer>
                <FlexContainer>
                    <Label>Search Exact AWB/ULD</Label>
                    <CustomInput value={search} onChange={e => setSearch(e.target.value)} />
                    <ActionIcon
                        type={'search'}
                        onClick={() => trySearch()}
                    />
                    <ActionIcon
                        type={'refresh'}
                        onClick={() => getData()}
                    />
                </FlexContainer>
                <ActionIcon
                    type={'add'}
                    onClick={() => setModal(true)}
                />
            </SearchContainer>
            <VirtualTable<Collection>
                data={collections}
                mapping={[{
                    name: 'AWB/ULD',
                    value: 'title',
                    customWidth: 200
                }, {
                    name: 'User',
                    value: 'createdBy',
                    customWidth: 250
                }, {
                    name: 'Date',
                    value: 'createdAt',
                    datetime: true
                }, {
                    name: 'Comments',
                    value: 'comments'
                }]}
                numRows={15}
                handleClick={item => viewReport(item.collectionId)}
            />
            {/* <RenderSearchResults
                searchComplete={searchComplete}
                data={data}
            /> */}
            <LightBox 
                lightBoxOpen={lightBoxOpen}
                setLightBoxOpen={setLightBoxOpen}
                collection={collection}
            />
            <ModalAddDamageReport
                modal={modal}
                setModal={setModal}
                submitDamageReport={submitDamageReport}
            />
        </Container>
    );
}

// const RenderSearchResults = ({
//     searchComplete,
//     data
// }: {
//     searchComplete: boolean;
//     data: Array<IVisualReporting>;
// }) => {

//     const images: Array<RenderImage> = data.map(item => ({
//         url: item.file_link,
//         title: item.awb_uld,
//         comments: item.comments,
//         collection_id: item.collection_id,
//         createdBy: item.user_submitted,
//         createdAt: item.time_submitted
//     }));

//     const {
//         user_submitted = null,
//         time_submitted = null,
//         comments = null,
//         awb_uld = null,
//         collection_id = null
//     } = data?.[0] || {};


//     return (
//         <RenderImages
//             searchComplete={searchComplete}
//             images={images}
//             createdBy={user_submitted}
//             createdAt={time_submitted}
//             comments={comments}
//             reportType={'DAMAGE'}
//             title={awb_uld}
//             collection_id={collection_id}
//         />
//     );

// }

const Container = styled.div`
    
`;

const FlexContainer = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 20px;
`;

const SearchContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;


const CustomInput = styled(Input)`
    width: 250px;
`;

const ImagesContainer = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
`;

export default withRouter(DamageReporting);